import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import {CampaignSetupAgentToolName} from '../../campaignSetupAgent.enums';
import {productCardSchema} from '../../schemas/productCardSchema';
import addOrUpdateCardTool from '../general/addOrUpdateCardTool/addOrUpdateCardTool';
import getProductFeedColumnsTool from './getProductFeedColumnsTool';
import getProductFeedTool from './getProductFeedTool';
import getProductMatchingSignalTool from './getProductMatchingSignalTool';
import matchStrategyTool from '../strategy/matchStrategyTool';

export default function addOrUpdateProductCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.PRODUCTS,
    cardSchema: productCardSchema,
    description: 'Add or update SINGLE Products card. Can search for product feeds by prompt.',
    tools: [
      getProductFeedTool(),
      getProductMatchingSignalTool(store),
      getProductFeedColumnsTool(),
      matchStrategyTool(store),
    ],
    cardSpecificInstructions: `1. If a product feed ID is provided, use it directly. Only use the ${CampaignSetupAgentToolName.GetProductFeeds} tool if no ID is provided or if the user provided other search details.
1.1. Once you have the feed, use its product type and other metadata where required.
2. YOU MUST ALWAYS Use the ${CampaignSetupAgentToolName.MatchStrategy} tool to find the best product selection strategy, following the user's request.
3. When dealing with custom matching or condition based strategy: 
3.1. use the ${CampaignSetupAgentToolName.GetProductMatchingSignal} tool to find the best matching signal following user's request.
3.2. use the ${CampaignSetupAgentToolName.GetProductFeedColumns} tool to find the best matching feed column following user's request.`,
  });
}
